import React from 'react';
import LoadingSpinner from './loadingSpinner'
import C18Input00 from './C18Input00.js'
import Gauge2 from '../../visualization/components/Gauge01'
import {getEquipmentStatus} from './C18EquipmentStatus00'
import history from "../../history"
import C18ColorPicker from './C18ColorPicker.js';
import C18Button00 from './C18Button00.js'
import C18SiteZoneView00 from './C18SiteZoneView00.js'
import Select from 'react-select'
import {dbVals,getZoneControllers} from '../../components/utils/http.js'
import {wsTrans,sensorIds,chanPosIds,doGetPostBasic,setSensorIdNames,getChannelsInfo,
  initSensorIds} from '../utils/utils.js'
import {cl, globs,constant,getTime,dateToShortMonth,az,getRandomString} from '../../components/utils/utils.js';
import {loadSitesInfo,loadSiteData,loadSensorsInfo,getSensorsZone,loadZonesInfo,getZoneInfo,
  loadPrivsInfo,privs,getZoneIndex, getZoneId,loadTagsInfo,updateSensor,loadViewPresetsInfo,getViewPresetIndex,getSuperUserFlags} from './C18utils.js'
import '../../rdr_styles.css'
import '../../rdr_default.css'
import C18LabeledInput from "./C18LabeledInput";
import C18PhysicalView from "./C18PhysicalView";

class C18View extends React.Component{
  constructor(props) {
    super(props);
    this.state={
      editing: (props.parms.pageType === "editView"), // in edit or view mode
      visibility: 1, // slider toggle to show "none" (no groups/points), "partial" (all groups, points of groups selected), "full" (groupings, points, etc)
      testing: false,
      selectedGroupingId: "",
      selectedPointId: "",
      selectedReadingId: "",
      site: "",
      zone: "",
      pageTitle: "New View",
      saveViewName: "New View",
      saveClassName: "filled",
      saveMsg:"Save",
      // below fields make up "View" object
      presetId: "",
      name:"",
      groupings: {},
      bgImgSrc: "https://foto.wuestenigel.com/wp-content/uploads/api/birds-eye-view-of-two-greenhouses-aerial-photography.jpeg",
    }
    this.visibilityArr = ["None", "Partial", "Full"]
    this.colorArr=[
      "#009fb9", 
      "#df568b", "#9b8610", "#348bed", "#dc5e59", "#679525", 
      "#00a086", 
      "#9478e0", 
        "#c3732e", "#009d52", "#0098df", "#c862bc"]
    this.isSuper=getSuperUserFlags()&(constant.SUPER_PRIVS_ADMIN)
    props.parms.onChange({cmd:"pageTitle",data:{pageTitle:this.state.pageTitle}})
    this.subscribe_savePageEvent=globs.events.subscribe("savePageEvent",this.saveView)
    this.loadInfo()
  }

  componentWillUnmount=()=>{
    cl("component unmounted")
    this.mounted=false
    this.subscribe_savePageEvent.remove()
    if (this.saveInt) {
      clearTimeout(this.saveInt)
    }
    clearInterval(this.checkNewData)
  }

  setBreadCrumbs=async()=>{
// the breadcrumbs can be /graphing, /sites/xxx/graph, /sites/xxx/zones/xxx/graph, /sites/xxx/zones/xxx/sensor/xxx
// props can contain site: zone: sensor: equip:
    await loadSitesInfo()
    await loadZonesInfo()
//       cl(this.props)
    let presetName=globs.presetsInfo.info[getViewPresetIndex(this.props.parms.presetId)]?.name||"New View"
    let bc=[
      {t:"Sites", url:"/usa/c18/sites"},
    ]
    if(["viewView","editView"].includes(this.props.parms.pageType)){
      bc.push({t:"Physical View", url:`/usa/c18/reports/viewList`})
      if(this.props.parms.pageType==="viewView"){
        bc.push({t:presetName, name:true, url:`/usa/c18/reports/viewView/${this.props.parms.presetId}`})
      }else{
        bc.push({t:presetName, name:true, url:`/usa/c18/reports/editView/${this.props.parms.presetId}`})
      }
    }
    this.props.parms.onChange(
      {
        cmd: "breadcrumbs",
        data: {breadcrumbs:bc},
      },
    )
  }
  
  componentDidMount=()=>{
    this.mounted=true
  }

  checkNewData=()=>{
    cl("refreshing data for sensors")
    let groupings = {}
    Object.assign(groupings, this.state.groupings)
    // iterate through the points and update the data they hold
    cl(groupings)
    Object.values(groupings).forEach((g, i) => {
      Object.values(g.points).forEach((p, i) => {
        this.makeSensors(p)
        g.points[p.id] = p
      })
      groupings[g.id] = g
    })
    this.setState({groupings: groupings})
  }
  
  getViewPresetIndex=(presetId)=>{
    let gspi=globs.viewPresetsInfo.info
    for(let i=0;i<gspi.length;i++){
      if(gspi[i].presetId===presetId){ return i }
    }
    return -1// not found
  }
  
  savePresetLocal=(pr)=>{// if presetId is found, then update, else insert
    cl(pr)
    if(!pr){return}
    cl(globs.viewPresetsInfo)
    let gspi=globs.viewPresetsInfo.info
    let i=this.getViewPresetIndex(pr.presetId)
    if(i>=0){
      Object.assign(gspi[i],pr)
    }else{
      gspi.push(Object.assign({},pr))
    }
  }
  
  loadPreset=(presetId)=>{
    let i=this.getViewPresetIndex(presetId)
    if(i>=0){// if found
      let gspi=globs.viewPresetsInfo.info
      let pr=Object.assign({},gspi[i])
      cl(pr)
      let pageTitle=`${pr.name} View`
      this.setState(Object.assign({saveViewName: pr.name, loaded: true, writePriv:(privs("account",0,constant.AREA_PRIVS_WRITE)!==0)}, pr))
      this.props.parms.onChange({cmd:"pageTitle",data:{pageTitle:pageTitle}})
    }else{
      cl("no preset found even though id given, making a new view")
      this.setState({loaded:true, writePriv:(privs("account",0,constant.AREA_PRIVS_WRITE)!==0)})
    }
  }
  
  setChannelInfo=(zoneId)=>{
//     cl(zoneId)
//     let site=globs.userData.session.siteId
//     let zoneId=this.props.parms.zone||getZoneId(site,0)
    let zone=globs.zonesInfo.info[getZoneIndex(zoneId)]// ||cp.zone is a hack until we can     
//     cl(zone)
//     cl(zoneId)
    let res=getChannelsInfo(zone?.siteZoneIndex,this.zoneControllers)// gets for all channels, including expansion controller
//     cl(res)
    let ci={}
    res.forEach(ch=>{
//       cl(ch)
      if(ch.type<constant.EQ_2ND_VENT){
        let u=Math.floor(ch.index/40)
        let id=`e${u}c`+(`00${ch.index}`).slice(-2)
        ci[id]=ch
      }
    })
    Object.keys(ci).forEach(k=>{
      let c=ci[k]
//       cl([k, c])
      this.sensorOptions.push({
        value:k,label:c.name
      })
    })
    
  }
  
  loadInfo=async()=>{
    await loadSitesInfo()
    await loadZonesInfo()
    await loadViewPresetsInfo()
    await loadPrivsInfo()
    await loadTagsInfo()
    let defaultZone=globs.zonesInfo.info.filter(z=>{return z.inNet})[0]
    if(!defaultZone){
      defaultZone=globs.zonesInfo.info[0]
    }
    let p=Object.assign({},this.props.parms)
    
    if(["viewView","editView"].includes(p.pageType) && p.presetId){
        this.loadPreset(p.presetId)
        // check all sites/zones on this account to see if this preset id belongs to any
        this.findAssociatedSiteZone(p.presetId)
    } else {
        this.setState({loaded:true, writePriv:(privs("account",0,constant.AREA_PRIVS_WRITE)!==0)})
    }
    this.setBreadCrumbs()
    // set refresh for every 15 seconds
    this.checkNewData = setInterval(this.checkNewData, 15000) 
  }

  findAssociatedSiteZone=(presetId)=>{
    let zi=globs.zonesInfo.info.filter(z=>{return z.viewId===presetId})[0]
    if (zi) {
      this.associatedUrl = `/usa/c18/sites/${zi.siteId}/zones/${zi.zoneId}`
      this.associatedName = zi.zoneName
      return
    }
    let si=globs.sitesInfo.info.filter(s=>{return s.viewId===presetId})[0]
    if (si) {
      this.associatedUrl = `/usa/c18/sites/${si.siteId}`
      this.associatedName = si.name
      return
    }
  }

  isChan=(sensorId)=>{
    let sensor2
    if(["e0","e1","e2","e3","ca"].includes(sensorId.substring(0,2))){
      sensor2=sensorId.substring(2)
    }
      return ((sensor2[0]==="c")&&(!isNaN(sensor2.substring(1,3))))
  }

  getZone=(zoneId)=>{
    let zone=globs.zonesInfo.info[getZoneIndex(zoneId)]
    if(!zone){return}
    return zone

  }

  
  makeSensors=(cp)=>{// should be done whenever the sensor list changes?
    if(!cp){return}
    cl(cp)
    cp.sensors.forEach((s, i, sensors)=>{// "c00" is the "sensor" for channel 0
      cl(s)
      let zone=globs.zonesInfo.info[getZoneIndex(s.zoneId)]
      cl(zone)
      // do update sensor here to get real time data? Is this what we call whenever we have sensors????
      var sensor = true
      cl(this.isChan(s.id))
      if (sensor) {
        sensors[i] = Object.assign(s, updateSensor({}, zone.gatewayType||1800, s.id, zone.siteId, zone.siteZoneIndex, {}))
      } else {
        // do I need to handle equipment differently?
        let i = 0 // channel index
        let chFull = dbVals.z[zone.siteZoneIndex][i]
        sensors[i] = Object.assign(s, getEquipmentStatus(zone.gatewayType||1800, zone.siteZoneIndex, i, chFull))
      }
    })
  }

  saveView=async()=>{
    if(this.state.saveViewName){
      // make save object
      let currTime = getTime()
      let pr=Object.assign({},{
        presetId: this.state.presetId,
        name: this.state.saveViewName,
        groupings: this.state.groupings,
        bgImgSrc: this.state.bgImgSrc,
      })
      if(!pr.presetId){// no id, must be a new view
        // get id from url if present?
        pr.presetId=this.props.parms.presetId || getRandomString(16)// save as a new preset
        pr.name=this.state.saveViewName
        pr.userId=globs.userData.session.userId // creator
        pr.createdOn = currTime
        // save to url so we're now editing
        history.replace(`/usa/c18/reports/editView/${pr.presetId}`)
      }
      pr.updatedOn = currTime
      this.savePresetLocal(pr)
      globs.events.publish("viewsUpdated",pr.presetId)
      wsTrans("usa", {cmd: "cRest", uri: "/s/viewPresets", method: "update", 
        sessionId: globs.userData.session.sessionId, body:pr})
      this.setState({presetName:this.state.saveViewName, presetId: pr.presetId, saveMsg:"Saving", saveClassName: "outline"})
      this.saveInt=setTimeout(()=>this.setState({saveMsg:"Save", saveClassName: "filled"}),3000 )
    }
  }

  sensorOptions=[
    {value:"inT",label:"Inside Temperature"},//23
    {value:"inH",label:"Inside Humidity"},//27
    {value:"inL",label:"Inside Light"},//32
    {value:"inC",label:"Inside CO2"},//31
    {value:"ouT",label:"Outside Temperature"},//24
    {value:"ouH",label:"Outside Humidity"},//28
    {value:"ouL",label:"Outside Light"},//33
    {value:"bpT",label:"Black Plate Temp"},//80
    
    {value:"oWs",label:"Wind Speed"},//80// new
    {value:"oWd",label:"Wind Direction"},//80
    {value:"dPr",label:"Differential Pressure"},//80
    {value:"bPr",label:"Barometric Pressure"},//80
    {value:"ran",label:"Rain"},//80
    {value:"sno",label:"Snow"},//80
    {value:"vpd",label:"VPD"},//80

    {value:"stT",label:"Temperature Stage"},//6
    {value:"stH",label:"Humidity Stage"},//7
    {value:"spH",label:"Heat Setpoint"},//8
    {value:"spC",label:"Cool Setpoint"},//9
    {value:"spU",label:"Humidify Setpoint"},//10
    {value:"spD",label:"DeHum Setpoint"},//11
    {value:"alH",label:"High Alarm"},//19
    {value:"alL",label:"Low Alarm"},//18
    {value:"c00",label:"Channel 1 Position"},//104+channel snap offset *and* channel
    {value:"c01",label:"Channel 2 Position"},
    {value:"c02",label:"Channel 3 Position"},
    {value:"c03",label:"Channel 4 Position"},
    {value:"c04",label:"Channel 5 Position"},
    {value:"c05",label:"Channel 6 Position"},
    {value:"c06",label:"Channel 7 Position"},
    {value:"c07",label:"Channel 8 Position"},
    {value:"c08",label:"Channel 9 Position"},
    {value:"c09",label:"Channel 10 Position"},
    {value:"c10",label:"Channel 11 Position"},
    {value:"c11",label:"Channel 12 Position"},
    {value:"at0",label:"Analog Temperature 1"},
    {value:"at1",label:"Analog Temperature 2"},
    {value:"at2",label:"Analog Temperature 3"},
    {value:"at3",label:"Analog Temperature 4"},
    {value:"at4",label:"Analog Temperature 5"},
    {value:"vp0",label:"Vent Position 1"},
    {value:"vp1",label:"Vent Position 2"},
    {value:"vp2",label:"Vent Position 3"},
    {value:"vp3",label:"Vent Position 4"},
    {value:"vp4",label:"Vent Position 5"},
    {value:"sm0",label:"Soil Moisture 1"},
    {value:"sm1",label:"Soil Moisture 2"},
    {value:"sm2",label:"Soil Moisture 3"},
    {value:"sm3",label:"Soil Moisture 4"},
    {value:"sm4",label:"Soil Moisture 5"},
    {value:"ec0", label:"EC Tank 1"},//203 + offset + tank
    {value:"ph0", label:"pH Tank 1"},//218
    {value:"tp0", label:"Temp Tank 1"},//233
    {value:"ec1", label:"EC Tank 2"},
    {value:"ph1", label:"pH Tank 2"},
    {value:"tp1", label:"Temp Tank 2"},
    {value:"ec2", label:"EC Tank 3"},
    {value:"ph2", label:"pH Tank 3"},
    {value:"tp2", label:"Temp Tank 3"},
    {value:"ec3", label:"EC Tank 4"},
    {value:"ph3", label:"pH Tank 4"},
    {value:"tp3", label:"Temp Tank 4"},
    {value:"ec4", label:"EC Tank 5"},
    {value:"ph4", label:"pH Tank 5"},
    {value:"tp4", label:"Temp Tank 5"},
    {value:"ec5", label:"EC Tank 6"},
    {value:"ph5", label:"pH Tank 6"},
    {value:"tp5", label:"Temp Tank 6"},
    {value:"ec6", label:"EC Tank 7"},
    {value:"ph6", label:"pH Tank 7"},
    {value:"tp6", label:"Temp Tank 7"},
    {value:"ec7", label:"EC Tank 8"},
    {value:"ph7", label:"pH Tank 8"},
    {value:"tp7", label:"Temp Tank 8"},
  ]
  
  makeSensorOptions=async(zone,zInd)=>{
//     cl(zone,zInd)
//     cl(zone)
//     let zInd=getZoneInfo(zone).siteZoneIndex
    initSensorIds(zInd, true)
//     cl(Object.keys(sensorIds))
//     cl(zone)
    if(zone.zone=="allZones"){}else{
      await setSensorIdNames(zone)
    }
//     cl(sensorIds)
    this.sensorOptions=[]
    Object.keys(sensorIds).forEach(k=>{
      let s=sensorIds[k]
//       cl([k,s])
      this.sensorOptions.push({
        value:k,
        label:s.name
      })
    })
    this.sensorOptions.sort((a,b)=>{
      if(a.value>b.value){return 1}
      if(a.value<b.value){return -1}
      return 0
    })
  }
  
  showTitle=()=>{
    cl(this.state)
    return(
      <>
        <h2>{this.state.pageTitle}</h2>
        <div className="clearfloat"></div>
      </>
    )
  }

  resolvePopup=(e)=>{
    //     cl(e)
        let popup=this.state.popup
        popup.opacity=0
        this.setState({popup:popup})
        // if(resolve){resolve(e)}
  }

  markImage=async(e)=>{
    cl(e.target.files)
    let files=e.target.files[0]
    if (!files) return
    if ((files.size > (2e+7) ) || (!files.type.startsWith("image/"))) {
      cl(this.state.popup)
      let popup={
        opacity:1,
        text:"File must be an image and smaller than 20MB!",
        buttons:["Close"],
        resolve:e=>this.resolvePopup(e),
      }
      this.setState({popup:popup})
      return
    } 

    let imageId= getRandomString(16)
    cl(imageId)
    let ext=files.name.substr(files.name.lastIndexOf('.')+1)
    cl(ext)
    let data = new FormData()
    data.append("type", "view")
    data.append("sessionId", globs.userData.session.sessionId)
    data.append('file', files)
    data.append('id', imageId)
    let url=`${constant.expressUrl}/usa/images`
    let method="POST"
    let type="multipart/form-data"
    cl("post image")
    let ret=await doGetPostBasic(url, method, data, type)
    let ret2 = await ret.json()
    cl(ret2)
    // get url from ret
    if(ret2.result === "ok") {
      cl("stored image successfully")
      let path = `${constant.expressUrl}/usa/images/view/uploads/${imageId[0]}/${imageId[1]}/${imageId[2]}/${imageId.substr(3)}.${ext}`
      cl(path)
      this.setState({bgImgSrc: path})
    }
  }
  
  
  getSensorName=(id)=>{// this is done in the render routine
    let so=this.sensorOptions
//     cl(id,so)
    for(let i=0;i<so.length;i++){
      if(so[i].value==id){return so[i].label}
    }
  }
  
  makeChartElements=()=>{
    let ce=[]
    let point = this.findPoint(this.state.selectedPointId)
    point.sensors.forEach(s=>{
      if (s.zoneId===this.state.zone) {
        ce.push({value:s.id, label:s.name})
      }
    })
    return ce
  }
  
  showChartElements=()=>{
    return(
      <div className="chart-elements-container">
        <div className="title">Elements</div>
        <Select
          value={this.makeChartElements()}
          onChange={o=>{this.onChange("chartElements",o)}}
          options={this.sensorOptions}
          isMulti={true}
          isClearable={false}
        />        
      </div>
    )
  }
  
  fixAddedSensorUnits=(cmd,hist)=>{
//     cl(cmd)
//     cl(hist)
    if(!hist.data){return}
    cmd.sensors.forEach((s,i)=>{
//       cl(s)
      if(s.type=="addedSensor"){
        let key=`${s.s}-${s.z}-${s.c}-${s.i}`
        hist.data.sensors[key].forEach((d,i)=>{
          d.d=d.d/s.mult
        })
      }
    })
  }
  

  getElements=(vals)=>{
    let ce=[]
    vals.forEach(v=>{
      ce.push({id:v.value,zoneId:this.state.zone}/*v.value*/)
    })
//     cl(ce)
    return{sensors:ce}
    
  }
    
  onChange=async(type, vals)=>{
//     cl([type,vals])
    let st=this.state
    var cp
    var v
    var hist
    if(vals){v=vals.vals} 
//     let v=vals.vals
    let groupings = {}
    let selectedGrouping
    let selectedPoint
    let selectedReading
    switch(type){
      case "chartElements":
        let newSensors=this.getElements(vals).sensors
        cl(newSensors)
        var oldSensors=[]
        selectedPoint = this.findPoint(this.state.selectedPointId)
        cl(selectedPoint)
        selectedPoint.sensors.forEach(s=>{
          if(s.zoneId!=this.state.zone){oldSensors.push(s)}
        })
        cp=Object.assign({},selectedPoint,{sensors:oldSensors.concat(newSensors)})
        this.makeSensors(cp)
        Object.assign(groupings, this.state.groupings)
        selectedGrouping = this.findGrouping(this.state.selectedGroupingId)
        selectedGrouping.points[this.state.selectedPointId] = cp
        groupings[this.state.selectedGroupingId] = selectedGrouping
        this.setState({groupings: groupings})
        break
      case "szv":
        cl(type,vals)
        switch(vals.cmd) {
          case "newSiteZone":
            cl(vals)
            await loadSiteData(vals.site)
//             await this.makeSensorOptions(vals.zone)
            cl(globs.zonesInfo.info)
            let zi=globs.zonesInfo.info.filter(
              z=>{return z.zoneId===vals.zone})[0]
            cl(zi)
            if (zi) {
              let zInd=zi?.siteZoneIndex
              await this.makeSensorOptions(vals.zone,zInd)
              this.zoneControllers=getZoneControllers(zInd)
              this.setChannelInfo(vals.zone)
              cl(vals)
              this.setState({site:vals.site,zone:vals.zone})
              cl(this.state)
            }
            break
            default:
              break
        }
        break
      case "saveViewName":
        this.setState(vals)
        break
      case "visibility":
        cl("change visiblity to ", this.visibilityArr[vals.visibility])
        this.setState(vals)
        break
      case "saveView":
        this.saveView()
        break
      // cases for modifying grouping elements
      case "selectedGrouping":
        cl(type,vals)
        // modify value of selected grouping
        Object.assign(groupings, this.state.groupings)
        groupings[this.state.selectedGroupingId][vals.key] = vals.val
        this.setState({groupings: groupings})
        break
      case "deleteGrouping":
        // splice value
        Object.assign(groupings, this.state.groupings)
        delete groupings[this.state.selectedGroupingId]
        this.setState({selectedGroupingId: "", groupings: groupings})
        break
      case "selectedPoint":
        cl(type,vals)
        // modify value of selected grouping
        Object.assign(groupings, this.state.groupings)
        selectedGrouping = this.findGrouping(this.state.selectedGroupingId)
        cl(selectedGrouping.points[this.state.selectedPointId][vals.key])
        selectedGrouping.points[this.state.selectedPointId][vals.key] = vals.val
        groupings[this.state.selectedGroupingId] = selectedGrouping
        cl(selectedGrouping.points[this.state.selectedPointId][vals.key])
        this.setState({groupings: groupings})
        break
      case "deletePoint":
        // splice value
        Object.assign(groupings, this.state.groupings)
        selectedGrouping = this.findGrouping(this.state.selectedGroupingId)
        delete selectedGrouping.points[this.state.selectedPointId]
        groupings[this.state.selectedGroupingId] = selectedGrouping
        this.setState({selectedPointId: ""})
        break
      case "createPoint":
        // create a new point in center of selected group
        selectedGrouping = this.findGrouping(this.state.selectedGroupingId)
        const newPoint = {
          x: Math.round(selectedGrouping.x + selectedGrouping.width/2),
          y: Math.round(selectedGrouping.y + selectedGrouping.height/2),
          type: "",
          name: getRandomString(16),
          id: getRandomString(16),
          groupingId: selectedGrouping.id,
          sensors: [], // object containing referencing to data type
        };
        // add point to selected grouping
        selectedGrouping.points[newPoint.id] = newPoint
        this.setState({selectedPointId: newPoint.id})
        break
      case "downloadCsv":
        this.downloadCsv()
        break
      case "physview":
        // handle all commands from child physical view here
        // cl(type,vals)
        switch(vals.cmd) {
          case "createGrouping":
            // create a new group from canvas
            Object.assign(groupings, this.state.groupings)
            groupings[vals.val.id] = vals.val
            this.setState({groupings: groupings, selectedGroupingId: vals.val.id})
            break
          case "moveGrouping":
            // match id to find grouping
            // move position of group from canvas
            Object.assign(groupings, this.state.groupings)
            groupings[vals.vals.currGrouping.id] = {
              ...groupings[vals.vals.currGrouping.id],
              x: Math.round(vals.vals.newX),
              y: Math.round(vals.vals.newY),
            }
            this.setState({groupings: groupings})
            break
            // modify grouping
          case "selectGrouping":
            // select group from canvas
            this.setState({selectedGroupingId: vals.val.id})
            break
          case "createPoint":
            // create a new point in selected group from canvas
            selectedGrouping = this.findGrouping(this.state.selectedGroupingId)
            selectedGrouping.points[vals.val.id] = vals.val
            this.setState({selectedPointId: vals.val.id})
            break
          case "movePoint":
            // move position of point from canvas
            selectedGrouping = this.findGrouping(vals.vals.currPoint.groupingId)
            cl(selectedGrouping)
            if (selectedGrouping) {
              selectedGrouping.points[vals.vals.currPoint.id] = {
                ...vals.vals.currPoint,
                x: Math.round(vals.vals.newX),
                y: Math.round(vals.vals.newY),
              }
              Object.assign(groupings, this.state.groupings)
              this.setState({groupings: groupings})
            }
            break
          case "selectPoint":
            // select point from canvas
            // also assign selected group
            cl(vals.val)
            this.setState({selectedGroupingId: vals.val.groupingId, selectedPointId: vals.val.id})
            break
          case "moveReading":
            // move position of point from canvas
            selectedGrouping = this.findGrouping(vals.vals.currReading.groupingId)
            // cl(vals.vals)
            if (selectedGrouping) {
              selectedPoint = selectedGrouping.points[vals.vals.currReading.pointId]
              if (selectedPoint) {
                // cl(selectedPoint)
                let selectedSensors = selectedPoint.sensors
                let selectedReadingIdx = this.findReadingIdx(vals.vals.currReading.pointId, vals.vals.currReading)
                selectedSensors[selectedReadingIdx].x = Math.round(vals.vals.newX)
                selectedSensors[selectedReadingIdx].y = Math.round(vals.vals.newY)
                selectedGrouping.points[vals.vals.currReading.pointId] = {
                  ...selectedPoint,
                  sensors: selectedSensors
                }
                Object.assign(groupings, this.state.groupings)
                this.setState({groupings: groupings})
              }
            }
            break
          case "selectReading":
            // select point from canvas
            // also assign selected group
            // cl(vals.val)
            this.setState({selectedGroupingId: vals.val.groupingId, selectedPointId: vals.val.pointId, selectedReadingId: vals.val.id})
            break
          default:
            break
        }
        break
      default:
        break
    }
    // set saveEnabled to true
    if (this.props.parms.editing) this.props.parms.onChange({cmd:"saveHeader",data:{saveEnabled:true}})
  }

  findPoint=(target)=>{
    let selectedGrouping = this.findGrouping(this.state.selectedGroupingId)
    return (selectedGrouping) ? selectedGrouping.points[target] : null
  }

  findGrouping=(target)=>{
    return this.state.groupings[target]
  }

  findReadingIdx=(targetPointId, target)=> {
    let selectedPoint = this.findPoint(targetPointId)
    if (selectedPoint) return selectedPoint.sensors.findIndex((s) => s.id === target.id && s.zoneId === target.zoneId)
  }

  showSaveThisView=()=>{
    return(
      <div style={{display: 'flex', flexDirection: "column", gap: '.5rem'}}>
        <h3>Save this view:</h3>
        <C18Input00 id="graphingPreset" type="text" placeholder="Name" 
          value={this.state.saveViewName}
          onChange={e=>this.onChange("saveViewName",{saveViewName:e.currentTarget.value})}
        />
        <div className="clearfloat"/>
        <div className="clearfloat"/>
        <C18Button00 type="button" className={this.state.saveClassName} onClick={o=>{this.onChange("saveView")}}>{this.state.saveMsg}</C18Button00>
      </div>
    )
  }
  
  showAllGroupings=()=>{
    // render all groupings as clickable buttons (think reports)
    let groupings = []
    Object.values(this.state.groupings).forEach((g, i) => {
      let selected = (this.state.selectedGroupingId === g.id) ? "toggle selected" : "toggle"
      // show as highlighted if selected
      groupings.push( 
        <button 
          key={i}
          onClick={()=>this.onChange("physview", {cmd: "selectGrouping", val: g})}
          type="button"
          id={g.id}
          className={selected}
          >
            {g.name}
        </button>
      )
    })
    return groupings
  }

  showSelectedPoints=()=>{
    // render all points as clickable buttons (only for the selected groupings)
    let points = []
    let selectedGrouping = this.findGrouping(this.state.selectedGroupingId)
    if (selectedGrouping.points) {
      Object.values(selectedGrouping.points).forEach((p, i) => {
        let selected = this.state.selectedPointId === p.id ? "toggle selected" : "toggle"
        // show as highlighted if selected
        points.push( 
          <button 
          key={i}
          onClick={()=>this.onChange("physview", {cmd: "selectPoint", val: p})}
          type="button"
          id={p.id}
          className={selected}
          >
            {p.name}
        </button>
        )
      })
    }
    return points
  }

  showSelectedGrouping=()=>{
    // show elements of selected grouping
    let selectedGrouping = this.findGrouping(this.state.selectedGroupingId)
    if (selectedGrouping) {
      return (
        <div>
          <h4>
            Selected Grouping
          </h4>
          <div style={{ display: 'flex', gap: '.75rem', alignItems: 'center'}}>

            <C18LabeledInput 
              parms={{
                name:"Name",
                value:selectedGrouping.name,
                onChange:e=>this.onChange("selectedGrouping",{key:"name", val: e.currentTarget.value})
              }}
            />

            <C18LabeledInput 
              parms={{
                name:"X Position",
                type:"number",
                value:selectedGrouping.x,
                onChange:e=>this.onChange("selectedGrouping",{key:"x", val: parseInt(e.currentTarget.value)})
              }}
            />

            <C18LabeledInput 
              parms={{
                name:"Y Position",
                type:"number",
                value:selectedGrouping.y,
                onChange:e=>this.onChange("selectedGrouping",{key:"y", val: parseInt(e.currentTarget.value)})
              }}
            />

            <C18LabeledInput 
              parms={{
                name:"Rotation",
                value:selectedGrouping.rotation,
                type:"number",
                unit: "°",
                onChange:e=>this.onChange("selectedGrouping",{key:"rotation", val: parseInt(e.currentTarget.value)})
              }}
            />

            <C18LabeledInput 
              parms={{
                name:"Width",
                type:"number",
                value:selectedGrouping.width,
                onChange:e=>this.onChange("selectedGrouping",{key:"width", val: parseInt(e.currentTarget.value)})
              }}
            />

            <C18LabeledInput 
              parms={{
                name:"Height",
                type:"number",
                value:selectedGrouping.height,
                onChange:e=>this.onChange("selectedGrouping",{key:"height", val: parseInt(e.currentTarget.value)})
              }}
            />

            <C18ColorPicker parms={{
              color: selectedGrouping.color,
              onChange: e=>this.onChange("selectedGrouping",{key:"color", val:e.currentTarget.value})
              }}
            />

            <button 
              onClick={()=>this.onChange("createPoint")}
              type="button">
                <span className="alarm-on material-icons-outlined" translate="no">
                  add_location
                </span>
            </button>

            <button
              onClick={()=>this.onChange("deleteGrouping")}
              type="button">
                <span className="alarm-on material-icons-outlined" translate="no">
                  delete
                </span>
            </button>
          </div>
          {Object.keys(selectedGrouping.points).length > 0 &&
            <h4>
              All Points for <span translate="no">{selectedGrouping.name}</span>
            </h4>
          }
          {this.showSelectedPoints()}
      </div>
     )
    }
  }

  showSelectedPoint=()=>{
    // show info for selected point
    // find selected grouping
    // find point from selected grouping
    let selectedPoint = this.findPoint(this.state.selectedPointId)
    if (selectedPoint) {
      return (
        <div>
          <h4>
            Selected Point
          </h4>
          <div style={{ display: 'flex', gap: '.75rem', alignItems: 'center'}}>

            <C18LabeledInput 
              parms={{
                name:"Name",
                value:selectedPoint.name,
                onChange:e=>this.onChange("selectedPoint", {key:"name", val: e.currentTarget.value})
              }}
            />

            <C18LabeledInput 
              parms={{
                name:"X Position",
                type:"number",
                value:selectedPoint.x,
                onChange:e=>this.onChange("selectedPoint", {key:"x", val: parseInt(e.currentTarget.value)})
              }}
            />

            <C18LabeledInput 
              parms={{
                name:"Y Position",
                type:"number",
                value:selectedPoint.y,
                onChange:e=>this.onChange("selectedPoint", {key:"y", val: parseInt(e.currentTarget.value)})
              }}
            />

            {/* select assigned sensor from dropdown, populated by chart elements*/}
            <>
              <C18SiteZoneView00 parms={{
                level:"account",
                site:this.state.site,
                zone:this.state.zone,
                pageType:this.props.parms.pageType,
                view:null,
                getPopup:this.props.parms.getPopup,
                onChange:e=>{this.onChange("szv",e)}
              }}/>
              <div style={{display:"inline-flex"}}>
                {this.state.zone&&
                  this.showChartElements(this.state.zone)}
              </div>
              <br/><br/>
            </>

            <button 
              onClick={()=>this.onChange("deletePoint")}
              type="button">
                <span className="alarm-on material-icons-outlined" translate="no">
                  delete
                </span>
            </button>

          </div>
      </div>
     )
    }
  }

  showAssociatedSiteZoneLink=()=>{
    // identify associated site/zone and navigate there if clicked?
    cl(this.associatedUrl)
    if (this.associatedUrl) {
      return (
        <C18Button00 type="button" className="filled" onClick={()=>history.push(this.associatedUrl)}>Go to <span translate="no">{this.associatedName}</span></C18Button00>
      )
    }
  }

  showUploadImage=()=>{
    return (
      <div>
        {/* button opens the hidden file input directly, so no overlay positioning needed */}
        <C18Button00 type="button" className="icon" onClick={()=>{
          let el=document.getElementById("physViewImageUpload")
          if(el){el.click()}
        }} style={{
          width:200, 
          height:40, 
          cursor: "pointer",
        }}>
          Upload Image
              <span className="material-icons-outlined" translate="no">
                upload_file
              </span>
        </C18Button00>
            
        <C18Input00 id="physViewImageUpload" type="file" accept="image/*" onChange={this.markImage}
          style={{display:"none"}}/>
      </div>
    )
  }

  showToggleEdit=()=>{
    let presetId = this.props.parms.presetId || this.state.presetId
    return (
      <div>
        <C18Button00 onClick={()=>{
          this.setState({editing: !this.state.editing})
          history.push(this.state.editing ? `/usa/c18/reports/viewView/${presetId}` : `/usa/c18/reports/editView/${presetId}`)
        }}type="button" className="icon" style={{
          width:200, 
          height:40, 
        }}>
          {`Switch to ${(this.state.editing) ? "View" : "Edit"}`}
              <span className="material-icons-outlined" translate="no">
                {(this.state.editing) ? "visibility" : "edit" }
              </span>
        </C18Button00>
        <C18Input00 
          style={{
            position:"absolute", 
            width:200, 
            height:40, 
            marginTop:-40, 
            zIndex:10,                   
            opacity:0,
            cursor: "pointer",
          }}
        />
      </div>
    )
  }

  showToggleTesting=()=>{
    return (
      <div>
        <C18Button00 onClick={()=>{
          this.setState({testing: !this.state.testing})
        }}type="button" className="icon" style={{
          width:200, 
          height:40, 
        }}>
          {`Toggle Test Mode`}
              <span className="material-icons-outlined" translate="no">
                experiment
              </span>
        </C18Button00>
        <C18Input00 
          style={{
            position:"absolute", 
            width:200, 
            height:40, 
            marginTop:-40, 
            zIndex:10,                   
            opacity:0,
            cursor: "pointer",
          }}
        />
      </div>
    )
  }

  showVisibilitySlider = () => {
    return (
      <div style={{
        display: "flex",
        alignItems: "center",
        gap: "1rem",
        width: '300px'}}
      >
       <span className="material-icons" translate="no">visibility_off</span>
        <input
          type="range"
          min="0"
          max="2"
          step="1"
          value={this.state.visibility}
          style={{flex: 1}}
          onChange={(e)=>this.onChange("visibility", {visibility: parseInt(e.currentTarget.value)})}
        />
        <span className="material-icons" translate="no">visibility</span>
      </div>
    )
  }



  render(){
    if(this.state.loaded){
      return(
        <div id="quickChart" onClick={e=>this.onChange("mainDiv",{})}>
                <div className="clearfloat"/>
                {this.state.editing && Object.keys(this.state.groupings).length > 0 &&
                  <h4>
                    All Groupings
                  </h4>
                }
                {this.state.editing && this.showAllGroupings()}
                {this.state.editing && this.showSelectedGrouping()}
                {this.state.editing && this.showSelectedPoint()}
                <div className="clearfloat"/>
                <C18PhysicalView parms={{
                  bgImgSrc:this.state.bgImgSrc,
                  groupings: this.state.groupings,
                  editing: this.state.editing,
                  visibility: this.state.visibility,
                  testing: this.state.testing,
                  onChange:e=>{this.onChange("physview",e)},
                  getZone:this.getZone,
                }}/>
                <div className="clearfloat"/>
                <div style={{display:'flex', flexDirection: "column", gap: '.5rem', alignItems: 'flex-end'}}>
                  {!this.state.editing && this.showVisibilitySlider()}
                  {(this.props.parms.presetId || this.state.presetId) && this.showToggleEdit()}
                  {false && this.isSuper && this.showToggleTesting()}
                  {this.state.editing && this.showUploadImage()}
                  <div className="clearfloat"/>
                  {(this.state.editing && this.state.writePriv) && this.showSaveThisView()}
                  <div className="clearfloat"/>
                  {this.showAssociatedSiteZoneLink()}
                </div>
        </div>
      )
    }else{
      return <LoadingSpinner message="Loading..." />
    }
  }
}

export default C18View;

